import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { BottomSheetBody, FlexColumn, TextBody } from "@opensea/ui-kit"
import { uniqBy } from "es-toolkit/compat"
import { useTranslations } from "use-intl"
import { Button } from "../../../../../components/Button"
import { TransactionFullScreen } from "../../../../../components/TransactionFullScreen"
import { useNavigation } from "../../../../../providers/NavigationProvider"
import { ListingFlowDone_itemFragment } from "./ListingFlowDone.fragment"

export const ListingFlowDone = ({
  title,
  body,
  items: itemsKey,
  withLink,
  withError,
}: {
  title: string
  body?: string
  items: FragmentOf<typeof ListingFlowDone_itemFragment>[]
  withLink?: boolean
  withError?: boolean
}) => {
  const t = useTranslations("wallet.ListingFlowDone")
  const { renderLink: Link, onClick } = useNavigation()
  const items = itemsKey.map(item =>
    readFragment(ListingFlowDone_itemFragment, item),
  )

  const collections = uniqBy(
    items.map(item => item.collection),
    "id",
  )
  const collection = collections.length === 1 ? collections[0] : undefined

  const item = items[0]
  // TODO: Create a helper function and fragment for this
  const itemUrl = `/item/${item.chain.identifier.toLowerCase()}/${item.contractAddress}/${item.tokenId}`

  const renderBottom = () => {
    if (!withLink) {
      return null
    }
    if (items.length === 1) {
      return (
        <FlexColumn className="items-center gap-4">
          <TextBody>
            {t("youListed")}{" "}
            <Link href={itemUrl} onClick={onClick}>
              {item.name}
            </Link>
            <CollectionCopy collection={collection} />!
          </TextBody>
          <Button href={itemUrl} size="lg" variant="secondary">
            {t("viewItemPage")}
          </Button>
        </FlexColumn>
      )
    }
    return (
      <TextBody>
        {t("youListedMultiple", { count: items.length })}
        <CollectionCopy collection={collection} />!
      </TextBody>
    )
  }

  return (
    <BottomSheetBody>
      <TransactionFullScreen
        body={body}
        bottom={renderBottom()}
        images={items.map(item => item.imageUrl)}
        monochrome={withError}
        title={title}
      />
    </BottomSheetBody>
  )
}

type CollectionCopyProps = {
  collection?: { name: string; slug: string } | null
}

function CollectionCopy({ collection }: CollectionCopyProps) {
  const t = useTranslations("wallet.ListingFlowDone")
  const { renderLink: Link, onClick } = useNavigation()
  if (!collection) {
    return null
  }
  return (
    <>
      {" "}
      {t("fromThe")}{" "}
      <Link href={`/collection/${collection.slug}`} onClick={onClick}>
        {collection.name}
      </Link>{" "}
      {t("collection")}
    </>
  )
}
